import React from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotSidebarHistory');
var _ref = /*#__PURE__*/React.createElement(Text, {
  type: "h4"
}, "History");
const CopilotSidebarHistoryTab = () => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, _ref);
};
export default CopilotSidebarHistoryTab;